import { useCallback, useEffect, useState } from 'react';
import { useLocalStorage } from 'usehooks-ts';

import { RETARGETING_CONFIG, STORAGE_KEYS } from '../constants';

export const useBotDetector = () => {
  const [clickCounter, setClickCounter] = useState(0);

  const [isHidePageOpened] = useLocalStorage<number | null>(
    STORAGE_KEYS.HIDE_PAGE_OPENED,
    null
  );

  const botDetecting = useCallback(() => {
    // Check for webdriver (automated browser)
    if (navigator.webdriver) return true;

    // Check for bot user agents
    if (navigator.userAgent.toLowerCase().includes('googlebot')) return true;

    // Check if hide page was opened
    if (isHidePageOpened) return true;

    // Check if user has made minimum required clicks
    if (clickCounter < RETARGETING_CONFIG.minClicksRequired) return true;

    return false;
  }, [clickCounter, isHidePageOpened]);

  useEffect(() => {
    const handler = () => setClickCounter((prev) => prev + 1);
    window.addEventListener('click', handler);

    return () => {
      window.removeEventListener('click', handler);
    };
  }, []);

  return { isUserBot: botDetecting() };
};
